import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'

import { stateComponentComplete } from '../models'
import { sendDataLayer } from '../helpers'

import { Box } from "@mui/material";
import { FaFacebookF, FaInstagram, FaTiktok, FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
    const location = useLocation()

    const [render, setRender] = useState<stateComponentComplete>({ ready: false})
    useEffect(() => {
        if (render.ready) sendDataLayer('onload-pager', location.pathname)
        setRender({ ready: true})
    }, [location.pathname, render.ready])
    const Facebook = FaFacebookF as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
    const Instagram = FaInstagram as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
    const Tiktok = FaTiktok as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
    const Linkedin = FaLinkedinIn as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
    return (
        <main className='container_footer'>
            <section className='container_footer_comp'>
                <div className='footer_left'>
                    <img
                        src='/assets/logo_white.webp'
                        alt='logo'
                        className='logo_footer'
                    />
                    <Box
                        component="footer"
                        className='footer_center'
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            gap: 3,
                        }}
                        >
                            <a 
                                href="https://www.facebook.com/Profuturo.mx"
                                target="_blank"
                                rel="noopener noreferrer">
                                <Facebook className="footer-icon"/>
                            </a>
                            <a 
                                href="https://www.instagram.com/profuturomx/"
                                target='_blank'
                                rel='noopener noreferrer'>
                                <Instagram className="footer-icon"/>
                            </a>
                            <a 
                                href="https://www.tiktok.com/@profuturomx"
                                target='_blank'
                                rel='noopener noreferrer'>
                                <Tiktok className="footer-icon"/>
                            </a>
                            <a 
                                href="https://www.linkedin.com/company/profuturomx/posts/?feedView=all"
                                target='_blanket'
                                rel='noopener noreferrer'>
                                <Linkedin className="footer-icon"/>
                            </a>    
                    </Box>
                        
                    <div className='footer_right'>
                        <p className='text_aviso'>
                            <a href="/aviso-de-privacidad" target='_blanket' rel='noopener noreferrer'>
                            Aviso de Privacidad
                            </a>
                        </p>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default Footer